var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1171275857(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#DF4E10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 32.75C13 32.3358 13.3358 32 13.75 32H31.75C32.1642 32 32.5 32.3358 32.5 32.75C32.5 33.1642 32.1642 33.5 31.75 33.5H13.75C13.3358 33.5 13 33.1642 13 32.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20.1309C13 19.1666 13.7858 18.3809 14.75 18.3809H16.35C17.3142 18.3809 18.1 19.1666 18.1 20.1309V28.7509C18.1 29.7151 17.3142 30.5009 16.35 30.5009H14.75C13.7858 30.5009 13 29.7151 13 28.7509V20.1309ZM14.75 19.8809C14.6142 19.8809 14.5 19.9951 14.5 20.1309V28.7509C14.5 28.8866 14.6142 29.0009 14.75 29.0009H16.35C16.4858 29.0009 16.6 28.8866 16.6 28.7509V20.1309C16.6 19.9951 16.4858 19.8809 16.35 19.8809H14.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1992 16.9395C20.1992 15.9752 20.985 15.1895 21.9492 15.1895H23.5492C24.5134 15.1895 25.2992 15.9752 25.2992 16.9395V28.7495C25.2992 29.7137 24.5134 30.4995 23.5492 30.4995H21.9492C20.985 30.4995 20.1992 29.7137 20.1992 28.7495V16.9395ZM21.9492 16.6895C21.8134 16.6895 21.6992 16.8037 21.6992 16.9395V28.7495C21.6992 28.8852 21.8134 28.9995 21.9492 28.9995H23.5492C23.685 28.9995 23.7992 28.8852 23.7992 28.7495V16.9395C23.7992 16.8037 23.685 16.6895 23.5492 16.6895H21.9492Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3984 13.75C27.3984 12.7858 28.1842 12 29.1484 12H30.7484C31.7126 12 32.4984 12.7858 32.4984 13.75V28.75C32.4984 29.7142 31.7126 30.5 30.7484 30.5H29.1484C28.1842 30.5 27.3984 29.7142 27.3984 28.75V13.75ZM29.1484 13.5C29.0127 13.5 28.8984 13.6142 28.8984 13.75V28.75C28.8984 28.8858 29.0127 29 29.1484 29H30.7484C30.8842 29 30.9984 28.8858 30.9984 28.75V13.75C30.9984 13.6142 30.8842 13.5 30.7484 13.5H29.1484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171275857);
export default __webpack_public_path__ + "static/media/Frame 1171275857.d2bce2dbe7d6bc4a4076234c7d04d730.svg";
export { ForwardRef as ReactComponent };